export const Data = [
  {
    to: 'Contact',
    icon: 'phone',
    color: 'brown-text text-darken-1',
    text: 'Contact',
  },
  {
    to: 'About',
    icon: 'user',
    color: 'green-text text-lighten-1',
    text: 'About',
  },
  {
    to: 'Projects',
    icon: 'briefcase',
    color: 'cyan-text text-darken-1',
    text: 'Experience',
  },
  {
    to: 'Skills',
    icon: 'chart-bar',
    color: 'pink-text text-lighten-1',
    text: 'Skills',
  },
  {
    to: 'Education',
    icon: 'user-graduate',
    color: 'orange-text text-lighten-2',
    text: 'Education',
  },
  {
    to: 'Background',
    icon: 'user-cog',
    color: 'purple-text text-lighten-2',
    text: 'Background',
  },
  {
    to: 'Resume',
    icon: 'file-pdf',
    color: 'grey-text text-darken-2',
    text: 'Download Resume',
  },
  {
    to: 'WriteMe',
    icon: 'comment-dots',
    color: 'red-text text-darken-3',
    text: 'Write to Me',
  },
];
